// virtual max height inside the svg
const height = 80;
// apply compression to reduce variation between peaks and valleys
const compressionFactor = 0.8;

// data is downsampled channelData from audioBuffer
export function audioSamplesToSvg(
  data: Float32Array<ArrayBufferLike>,
  elementWidth: number | string,
  elementHeight: number | string
): string {
  const width = data.length * 2;

  // normalize samples
  const minSample = Math.min(...data);
  const maxSample = Math.max(...data);

  const points = [...data].map((sample, i) => {
    const baseNormalized =
      maxSample > minSample ? (sample - minSample) / (maxSample - minSample) : 0.5;
    const normalized = 0.5 + (baseNormalized - 0.5) * compressionFactor;
    const y = height - normalized * height + 0.5;
    return { x: i * 2, y };
  });

  // Function to generate a smooth curved path using Catmull-Rom to Bezier conversion
  function smoothCurvedPath(points: { x: number; y: number }[]): string {
    if (points.length < 2) {
      return "";
    }

    let pathData = `M ${points[0].x},${points[0].y}`;

    for (let i = 0; i < points.length - 1; i++) {
      const p0 = i > 0 ? points[i - 1] : points[i];
      const p1 = points[i];
      const p2 = points[i + 1];
      const p3 = i < points.length - 2 ? points[i + 2] : p2;

      // Convert Catmull-Rom to Bezier
      const cp1x = p1.x + (p2.x - p0.x) / 6;
      const cp1y = p1.y + (p2.y - p0.y) / 6;
      const cp2x = p2.x - (p3.x - p1.x) / 6;
      const cp2y = p2.y - (p3.y - p1.y) / 6;

      pathData += ` C ${cp1x},${cp1y} ${cp2x},${cp2y} ${p2.x},${p2.y}`;
    }

    return pathData;
  }

  // Create a smooth path for the top line
  const topPath = smoothCurvedPath(points);

  // Create the complete closed path
  const pathData = `${topPath} L ${width},${height} L 0,${height} Z`;

  // Generate SVG string with a more visible fill color
  return `<svg
    width=${elementWidth}
    height=${elementHeight}
    viewBox="0 0 ${width} ${height}"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
  >
    <path
      d="${pathData}"

      stroke-width="0.5"
    />
  </svg>`;
}
